export default __webpack_public_path__ + "static/media/oatmeal.b0757818.webp";